<template lang="html">
  <div class="mask-container">
    <input id="file" class="userCamera" @change="fileChange" type="file" capture="user" accept="image/*" multiple>
    <div class="upload-container">
      <div @click="close" class="close"></div>
      <div v-if="showFace===false" class="uploadBtn-container">
        <div v-if="canPhoto===false" class="uploadBtn">
          <img :class="canAnimate ? 'on' : ''" src="../assets/face1.png">
          <img src="../assets/face2.png">
          <img src="../assets/face3.png">
        </div>
        <video v-if="canPhoto" id="video"></video>
        <p v-if="showBtn" id="capture" class="faceBtn" v-text="$t('m.shoot')"></p>
        <div v-if="showPadBtn" @click="reRec" :class="language==='zh-CN' ? 'btn' : 'btn on'" v-text="$t('m.reIdentification')"></div>
        <canvas id="canvas" width="160" height="160"></canvas>
      </div>
      <div v-if="showFace" class="pic-container">
        <img :src="faceList[index].pic_url">
        <div class="peopleName">
          <div class="character-container">
            <span v-text="$t('m.similarCharacters')"></span>
            <div>
              <p @click="index=key;navigateToSearchList(item.name)" v-for="(item,key) in faceList">{{item.name}}</p>
            </div>
          </div>
          <div @click="reRec" :class="language==='zh-CN' ? 'btn' : 'btn on'" v-text="$t('m.reIdentification')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import bus from '../bus'

export default {
  data() {
    return {
      language: 'zh-CN',
      isPc: false,
      canPhoto: true,
      showFace: false,
      canAnimate: false,
      showBtn: true,
      showPadBtn: false,
      media: null,
      faceList: [],
      index: 0
    }
  },
  methods: {
    close() { // 关闭文件上传弹框
      bus.$emit('closeFaceUpload')
      if(this.media!=null){
        this.media.getTracks()[0].stop();
      }
    },
    IsPC() { // 判断是否是PC端
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                  "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
      return flag;
    },
    fileChange() { // input框上传监听文件改变事件
      var that = this;
      that.canPhoto = false;
      that.canAnimate = true;
      that.showBtn = false;
      that.showPadBtn = false;
      var file = document.getElementById("file").files[0];
      require('../utils.js').uploadWithToken({
        url: require('../config.json').urlBase + require('../config.json').url.pic.imgrec,
        data: {
          imageFile: file
        },
        success: function(res) {
          if(res.code=='10000'){
            if(res.result.length>0){
              that.index = 0;
              var picList = [];
              res.result.forEach(function(el){
                // if(el.score >= 0.80){
                  picList.push(el)
                // }
              })
              that.faceList = picList;
              that.showFace = true;
              that.canPhoto = true;
              that.canAnimate = false;
              bus.$emit('search',{
                search: res.result[0].name
              })
            }else{
              that.showFace = false;
              that.canAnimate = false;
              that.showPadBtn = true;
              that.faceList = [];
              bus.$emit('search',{
                search: ''
              })
              if(that.language==='zh-CN'){
                that.$message({
                  type: 'warning',
                  message: '未识别到人像'
                })
              }else{
                that.$message({
                  type: 'warning',
                  message: 'No portrait recognized'
                })
              }
            }
          }
        },
        error: function() {
          if(that.language==='zh-CN'){
            that.$message({
                type: 'error',
                message: '网络错误'
            })
          }else{
            that.$message({
                type: 'error',
                message: 'Network Error'
            })
          }
        }
      })
    },
    navigateToSearchList(name) { // 跳转搜索列表
      bus.$emit('closeFaceUpload')
      bus.showAll = true;
      this.$router.push({
          name: 'searchList',
          params: {
              keyWord: encodeURIComponent(name)
          }
      })
    },
    reRec() { // 重新识别事件
      if(this.isPc){
        this.showFace = false;
        this.getUserMedia({video : {width: '4rem', height: '4rem'}}, this.success, this.error);
      }else{
        this.showFace = false;
        $('.userCamera').click();
      }
    },
    getUserMedia(constraints, success, error) { // 判断浏览器适配的api类型
      if (navigator.mediaDevices.getUserMedia) {
        //最新的标准API
        navigator.mediaDevices.getUserMedia(constraints).then(success).catch(error);
      } else if (navigator.webkitGetUserMedia) {
        //webkit核心浏览器
        navigator.webkitGetUserMedia(constraints,success, error)
      } else if (navigator.mozGetUserMedia) {
        //firfox浏览器
        navigator.mozGetUserMedia(constraints, success, error);
      } else if (navigator.getUserMedia) {
        //旧版API
        navigator.getUserMedia(constraints, success, error);
      }
    },
    success(stream) { // 调用摄像头成功事件
      var that = this;
      let video = document.getElementById('video');
      //兼容webkit核心浏览器
      let CompatibleURL = window.URL || window.webkitURL;
      //将视频流设置为video元素的源
      this.media = stream;
      //video.src = CompatibleURL.createObjectURL(stream);
      video.srcObject = stream;
      video.play();

      let canvas = document.getElementById('canvas');
      let context = canvas.getContext('2d');

      document.getElementById('capture').addEventListener('click', function () {
        if(that.canPhoto){
          that.canPhoto = false;
          that.canAnimate = true;
          that.showBtn = false;
          context.drawImage(video, 0, 0, 160, 160);
          var dataURL = canvas.toDataURL("image/png");
          require('../utils.js').uploadBase64WithToken({
            url: require('../config.json').urlBase + require('../config.json').url.pic.imgrec,
            data: {
              imagebase64: dataURL
            },
            success: function(res) {
              if(res.code=='10000'){
                if(res.result.length>0){
                  // var faceList = [];
                  // res.result.forEach(function(el){
                  //   if(el.score >= 0.80){
                  //     faceList.push(el);
                  //   }
                  // })
                  // if(faceList.length > 0){
                  //   that.index = 0;
                  //   that.faceList = faceList;
                  //   that.showFace = true;
                  //   that.canPhoto = true;
                  //   that.canAnimate = false;
                  //   that.showBtn = true;
                  // }else{
                  //   that.showFace = false;
                  //   that.canPhoto = true;
                  //   that.canAnimate = false;
                  //   that.showBtn = true;
                  //   that.faceList = [];
                  //   bus.$emit('search',{
                  //     search: ''
                  //   })
                  //   if(that.language==='zh-CN'){
                  //     that.$message({
                  //       type: 'warning',
                  //       message: '未识别到人像'
                  //     })
                  //   }else{
                  //     that.$message({
                  //       type: 'warning',
                  //       message: 'No portrait recognized'
                  //     })
                  //   }
                  //   that.getUserMedia({video : {width: '4rem', height: '4rem'}}, that.success, that.error);
                  // }
                  that.index = 0;
                  that.faceList = res.result;
                  that.showFace = true;
                  that.canPhoto = true;
                  that.canAnimate = false;
                  that.showBtn = true;
                  // bus.$emit('search',{
                  //   search: res.result[0].name
                  // })
                }else{
                  that.showFace = false;
                  that.canPhoto = true;
                  that.canAnimate = false;
                  that.showBtn = true;
                  that.faceList = [];
                  bus.$emit('search',{
                    search: ''
                  })
                  if(that.language==='zh-CN'){
                    that.$message({
                      type: 'warning',
                      message: '未识别到人像'
                    })
                  }else{
                    that.$message({
                      type: 'warning',
                      message: 'No portrait recognized'
                    })
                  }
                  that.getUserMedia({video : {width: '4rem', height: '4rem'}}, that.success, that.error);
                }
              }
            },
            error: function() {
              if(that.language==='zh-CN'){
                that.$message({
                    type: 'error',
                    message: '网络错误'
                })
              }else{
                that.$message({
                    type: 'error',
                    message: 'Network Error'
                })
              }
            }
          })
          that.media.getTracks()[0].stop();
        }else{
          if(that.language==='zh-CN'){
            that.$message({
              type: 'error',
              message: '未识别到摄像设备'
            })
          }else{
            that.$message({
              type: 'error',
              message: 'Camera device not recognized'
            })
          }
        }
      })
    },
    error(error) { // 调用摄像头失败事件
      var that = this;
      if(this.language==='zh-CN'){
        this.$message({
          type: 'error',
          message: '未识别到摄像设备'
        })
      }else{
        this.$message({
          type: 'error',
          message: 'Camera device not recognized'
        })
      }
      this.canPhoto = false;
      document.getElementById('capture').addEventListener('click', function () {
        if(that.language==='zh-CN'){
          that.$message({
            type: 'error',
            message: '未识别到摄像设备'
          })
        }else{
          that.$message({
            type: 'error',
            message: 'Camera device not recognized'
          })
        }
      })
    }
  },
  mounted() {
    var that = this;
    if(this.isPc){
      if (navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
        //调用用户媒体设备, 访问摄像头
        this.getUserMedia({video : {width: '4rem', height: '4rem'}}, this.success, this.error);
      } else {
        alert('不支持访问用户媒体');
      }
    }else{
      $('.userCamera').click();
      this.showFace = false;
      this.canPhoto = false;
      this.showBtn = false;
      this.showPadBtn = true;
    }
  },
  created() {
    this.language = this.$i18n.locale;
    this.isPc = this.IsPC()
  }
}
</script>

<style scoped>
  .mask-container {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 99;
    width: 100%;
    height: 100%;
    background: rgba(16,22,62,0.2);
  }

  .upload-container {
    position: fixed;
    bottom: 0px;
    left: 50%;
    margin-left: -9.4rem;
    width: 18.8rem;
    height: 5.12rem;
    border-radius: 6px 6px 0 0;
    background: #FFF;
    border: 0.04rem solid #e0e7ff;
    box-sizing: border-box;
  }

  .upload-container .close {
    position: absolute;
    top: 0.22rem;
    right: 0.17rem;
    width: 0.3rem;
    height: 0.3rem;
    background: url('../assets/close.png') no-repeat;
    background-position: center;
    background-size: 100%;
    cursor: pointer;
  }

  .upload-container .close:hover {
    position: absolute;
    top: 0.22rem;
    right: 0.17rem;
    width: 0.3rem;
    height: 0.3rem;
    background: url('../assets/closeOn.png') no-repeat;
    background-position: center;
    background-size: 100%;
  }

  .upload-container #video {
    width: 4rem;
    height: 4rem;
    margin: 0.2rem 0 0rem 0;
  }

  .upload-container .uploadBtn {
    position: relative;
    width: 2.6rem;
    height: 2.6rem;
    margin: 1.24rem 0 0.3rem 0;
  }

  .upload-container .uploadBtn img:nth-of-type(1) {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -0.04rem;
    margin-left: -1.06rem;
    width: 2.12rem;
    height: 0.08rem;
    z-index: 2;
  }

  .upload-container .uploadBtn img:nth-of-type(1).on {
    position: absolute;
    left: 50%;
    margin-top: -0.04rem;
    margin-left: -1.06rem;
    width: 2.12rem;
    height: 0.08rem;
    z-index: 2;
    animation: scan 5s infinite linear;
  }

  .upload-container .uploadBtn img:nth-of-type(2) {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -0.94rem;
    margin-left: -0.865rem;
    width: 1.73rem;
    height: 1.88rem;
    z-index: 1;
  }

  .upload-container .uploadBtn img:nth-of-type(3) {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -1.3rem;
    margin-left: -1.3rem;
    width: 2.6rem;
    height: 2.6rem;
  }

  .upload-container .pic-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0.94rem 0 0 4.02rem;
  }

  .upload-container .pic-container img {
    width: 2.8rem;
    height: 3.2rem;
    border-radius: 6px;
    box-sizing: border-box;
    overflow: hidden;
  }

  .upload-container .pic-container .peopleName {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 10rem;
    height: 3.2rem;
    margin-left: 0.58rem;
  }

  .upload-container .pic-container .peopleName .character-container {
    display: flex;
    flex-direction: row;
    font-size: 0.36rem;
    color: #848a9d;
    user-select: none;
  }

  .upload-container .pic-container .peopleName .character-container > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .upload-container .pic-container .peopleName .character-container span {
    margin-right: 0.3rem;
  }

  .upload-container .pic-container .peopleName .character-container p {
    color: #1e69fe;
    margin-right: 0.44rem;
    margin-bottom: 0.22rem;
    cursor: pointer;
  }

  .btn {
    width: 1.8rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.28rem;
    color: #1e69fe;
    border: 0.02rem solid #5e8df7;
    border-radius: 40px;
    box-sizing: border-box;
    /* margin-left: 5.46rem; */
    user-select: none;
    cursor: pointer;
  }

  .upload-container .pic-container .peopleName .btn {
    width: 1.8rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.28rem;
    color: #1e69fe;
    border: 0.02rem solid #5e8df7;
    border-radius: 40px;
    box-sizing: border-box;
    margin-left: 5.46rem;
    user-select: none;
    cursor: pointer;
  }

  .btn.on {
    width: 2.8rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.28rem;
    color: #1e69fe;
    border: 0.02rem solid #5e8df7;
    border-radius: 40px;
    box-sizing: border-box;
    /* margin-left: 5.46rem; */
    user-select: none;
    cursor: pointer;
  }

  .upload-container .pic-container .peopleName .btn.on {
    width: 2.8rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.28rem;
    color: #1e69fe;
    border: 0.02rem solid #5e8df7;
    border-radius: 40px;
    box-sizing: border-box;
    margin-left: 5.46rem;
    user-select: none;
    cursor: pointer;
  }

  .uploadBtn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .faceBtn {
    width: 1.8rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.28rem;
    color: #1e69fe;
    border: 0.02rem solid #5e8df7;
    border-radius: 40px;
    box-sizing: border-box;
    user-select: none;
    cursor: pointer;
  }

  #canvas {
    position: absolute;
    bottom: -999999px;
  }

  @keyframes scan {
    0% {
      top: 5%
    }
    50% {
      top: 95%
    }
    100% {
      top: 5%
    }
  }

  .userCamera {
    position: absolute;
    top: -999999px;
  }
</style>
